<div class="p-3 box h-100 overflow-auto crm-scroll">
  <mat-card class="shadow-none bg-transparent">
    <mat-card-content class="bg-white rounded-2 p-4">
      <div class="d-flex align-items-center gap-2 py-2">
        <app-search
          class="search transition"
          customClass="!text-gray-900 placeholder:!text-gray-400"
          (onValueChange)="onSearchChange($event)"
        ></app-search>
        <div class="flex-fill"></div>
        @if (canManageTeam) {
          <app-button (onChangeClick)="onCreateGroup()">{{ 'create_role' | translate }}</app-button>
        }
      </div>

      @if (isLoader) {
        <div class="d-flex justify-content-center">
          <app-loader size="small"></app-loader>
        </div>
      } @else {
        @if (dataSource$ | async; as dataSource) {
          <app-table
            (menuSelected)="onActionChange($event)"
            (onPaginationChange)="onPaginationChange($event)"
            (onSortChange)="onSortChange($event)"
            (onTableRowClick)="onRowClick($event.row)"
            [dataSource]="dataSource"
            [showUpPagination]="true"
            [visibleColumnKeys]="visibleColumns"
            class="w-100"
          ></app-table>
        }
      }
    </mat-card-content>
  </mat-card>
</div>
